// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const LegendBottomIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="LegendBottomIcon" ref={forwardedRef} {...props}>
      <path d="M16 2a1 1 0 0 1 1 1v3.5a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zM4.5 3.5V6h11V3.5z" />
      <path d="M4 11.004h12v-1.5H4z" />
      <path d="M16 14.504H4v-1.5h12z" />
      <path d="M4 18.004h12v-1.5H4z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const LegendBottomIcon = /* @__PURE__ */ Object.assign(
  LegendBottomIconComponent,
  { displayName: 'LegendBottomIcon' },
);
